module.exports = __webpack_public_path__ + "img/icon_btn_perce_w.d9ebb2e5.svg";